var _ellipse, _path, _path2, _path3, _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmptyJobs(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 200 160",
    fill: "none",
    role: "img",
    "aria-label": "\\u05D0\\u05D9\\u05DF \\u05DE\\u05E9\\u05E8\\u05D5\\u05EA",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 100,
    cy: 140,
    rx: 46,
    ry: 10,
    fill: "#d9dee2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M100 40 128 132H72L100 40Z",
    fill: "#1FA64A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M89 78h22l4 14H85l4-14Z",
    fill: "#ffffff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M83 100h34l4 14H79l4-14Z",
    fill: "#ffffff"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 64,
    y: 128,
    width: 72,
    height: 10,
    rx: 4,
    fill: "#1F2A33"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(126 92)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 22c0-2 1.5-3 3.5-3h21c2 0 3.5 1 3.5 3 0 1.5-1.2 2.5-3 2.5H3c-1.8 0-3-1-3-2.5Z",
    fill: "#1F2A33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 19c0-8 4-13 10-13s10 5 10 13H4Z",
    fill: "#8FD14F"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyJobs);
export default __webpack_public_path__ + "static/media/empty-jobs.923c5b089314d41539aa7536f1aac218.svg";
export { ForwardRef as ReactComponent };